﻿import React, { useRef, useState, useEffect, useContext } from "react";
import axios from "../../features/axiosHelper";
import { Box, Container, TextField, Button, Typography } from "@mui/material";
import "./Login.css";
import { useDispatch, useSelector } from "react-redux";
import { createAlert } from "@/features/homepage/alertSliceList";
import {
  selectUser,
  selectResetToken,
} from "../../features/auth/resetPasswordSlice";
import { store } from "../../store";

const ResetPassword = (props) => {
  const dispatch = useDispatch();
  const [NewPassword, setNewPassword] = useState("");
  const [NewPasswordConfirmation, setNewPasswordConfirmation] = useState("");
  const [Error, setError] = useState(false);
  const [TokenError, setTokenError] = useState(false);
  const resetToken = useSelector(selectResetToken);
  const handleNewPassword = (event) => {
    setNewPassword(event.target.value);
  };
  const handleNewPasswordConfirmation = (event) => {
    setNewPasswordConfirmation(event.target.value);

    if (event.target.value != NewPassword) {
      setError(true);
    } else {
      setError(false);
    }
  };
  const verifyPasswords = () => {
    if (NewPasswordConfirmation !== NewPassword || NewPassword === "") {
      setError(true);
    } else {
      axios
        .put("/login/users/reset", {
          UserId: props.userId,
          NewPassword: NewPasswordConfirmation,
          ResetToken: resetToken,
        })
        .then((response) => {
          let email = response.data;
          props.setEmail(email);
          props.setPassword(NewPasswordConfirmation);
          props.logIn(email, NewPasswordConfirmation);
          props.setIsResetPassword(false);
          props.setUserCredentialsPane(true);
          dispatch(
            createAlert({
              status: "Success",
              message: "Password Successfully Reset, Login and Continue",
            })
          );
        })
        .catch((err) => {
          console.log(err);
          setTokenError(true);
        });
    }
  };

  return (
    <div>
      <div className="centerContent">
        <div>
          <Typography
            sx={{
              color: "#FFFFFF !important",
              fontSize: "32px !important",
              fontWeight: "600 !important",
              fontFamily: "mortise !important",
            }}
          >
            Set a New Password
          </Typography>
          <br />
          {TokenError ? (
            <Typography sx={{ color: "red" }}>
              Reset link expired. Please close pop up and click 'forgot
              password' for new link
            </Typography>
          ) : (
            <Typography sx={{ color: "var(--text-adornment)" }}>
              Type in your new password
            </Typography>
          )}
        </div>
        <br />
        <br />
        <TextField
          fullWidth={true}
          id="password"
          className="login-fields"
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "var(--dark-border)",
              height: "60px",
              borderRadius: "8px",
              "& fieldset": {
                borderColor: "var(--neutral-6)",
                borderWidth: "1px",
              },
              "&:hover": {
                backgroundColor: "var(--dark-border)",
                boxShadow: "0px -1px 8.2px rgba(204, 204, 204, 0.75)",
                "& fieldset": {
                  borderColor: "var(--neutral-6)",
                  borderWidth: "1px",
                },
              },
              "&.Mui-focused": {
                backgroundColor: "var(--dark-border)",
                "& fieldset": {
                  borderColor: "var(--neutral-6)",
                  borderWidth: "1px",
                },
              },
              "& #userName-input.MuiInputBase-input": {
                color: "var(--default-light)",
                padding: "14px",
                height: "100%",
                "&::selection": {
                  backgroundColor: "#555",
                  color: "var(--default-light)",
                },
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                  WebkitTextFillColor: "var(--default-light)",
                  caretColor: "var(--default-light)",
                  borderRadius: "4px",
                  transition: "background-color 9999s ease-in-out 0s",
                },
                "&:-webkit-autofill:hover": {
                  WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                  WebkitTextFillColor: "var(--default-light)",
                },
                "&:-webkit-autofill:focus": {
                  WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                  WebkitTextFillColor: "var(--default-light)",
                },
              },
            },
            "&:-webkit-autofill": {
              WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
              WebkitTextFillColor: "var(--default-light)",
              caretColor: "var(--default-light)",
              borderRadius: "4px",
              transition: "background-color 9999s ease-in-out 0s",
            },
            "&:-webkit-autofill:hover": {
              WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
              WebkitTextFillColor: "var(--default-light)",
            },
            "&:-webkit-autofill:focus": {
              WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
              WebkitTextFillColor: "var(--default-light)",
            },
          }}
          label="New Password"
          type="password"
          onChange={handleNewPassword}
        />
        <br />
        <br />
        <TextField
          fullWidth={true}
          error={Error}
          helperText={Error ? "Passwords do not match" : ""}
          id="password2"
          className="login-fields"
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: "var(--dark-border)",
              height: "60px",
              borderRadius: "8px",
              "& fieldset": {
                borderColor: "var(--neutral-6)",
                borderWidth: "1px",
              },
              "&:hover": {
                backgroundColor: "var(--dark-border)",
                boxShadow: "0px -1px 8.2px rgba(204, 204, 204, 0.75)",
                "& fieldset": {
                  borderColor: "var(--neutral-6)",
                  borderWidth: "1px",
                },
              },
              "&.Mui-focused": {
                backgroundColor: "var(--dark-border)",
                "& fieldset": {
                  borderColor: "var(--neutral-6)",
                  borderWidth: "1px",
                },
              },
              "& #userName-input.MuiInputBase-input": {
                color: "var(--default-light)",
                padding: "14px",
                height: "100%",
                "&::selection": {
                  backgroundColor: "#555",
                  color: "var(--default-light)",
                },
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                  WebkitTextFillColor: "var(--default-light)",
                  caretColor: "var(--default-light)",
                  borderRadius: "4px",
                  transition: "background-color 9999s ease-in-out 0s",
                },
                "&:-webkit-autofill:hover": {
                  WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                  WebkitTextFillColor: "var(--default-light)",
                },
                "&:-webkit-autofill:focus": {
                  WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
                  WebkitTextFillColor: "var(--default-light)",
                },
              },
            },
            "&:-webkit-autofill": {
              WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
              WebkitTextFillColor: "var(--default-light)",
              caretColor: "var(--default-light)",
              borderRadius: "4px",
              transition: "background-color 9999s ease-in-out 0s",
            },
            "&:-webkit-autofill:hover": {
              WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
              WebkitTextFillColor: "var(--default-light)",
            },
            "&:-webkit-autofill:focus": {
              WebkitBoxShadow: "0 0 0 1000px var(--background-color) inset",
              WebkitTextFillColor: "var(--default-light)",
            },
          }}
          label="Confirm new password"
          type="password"
          onChange={handleNewPasswordConfirmation}
        />
        <br />
        <br />
        <Button
          onClick={() => verifyPasswords()}
          sx={{
            marginTop: "20px",
            width: "100%",
            height: "60px",
            backgroundColor: "var(--default-light)",
            color: "var(--text-primary)",
            fontFamily: "Montserrat",
            fontWeight: "medium",
            fontSize: "24px",
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "var(--text-primary)",
              fontWeight: 600,
              color: "var(--default-light)",
              border: "1px solid var(--default-light)",
            },
            "&:disabled": {
              backgroundColor: "var(--default-light)",
              color: "rgba(12,12,12,0.5)",
            },
            boxShadow: "none",
            "&.MuiButton-root": {
              boxShadow: "none",
            },
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default ResetPassword;
